module.exports = __webpack_public_path__ + "img/57eddfb001ea4dee9b2c323421a1164e.d1e7eeb9.jpg";